export default __webpack_public_path__ + "static/media/E-Bikebörse Logo 3.34569613.png";